import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const Messages = () => {
  const { t } = useI18n();
  const messages = [
    {
      header: 'register.steps.personalInfo.messages.dataCannotBeChanged',
      message: 'register.steps.personalInfo.messages.dataCannotBeChangedDetails'
    },
    {
      header: 'register.steps.personalInfo.messages.onlyOneAccount',
      message: 'register.steps.personalInfo.messages.onlyOneAccountDetails'
    }
  ];

  return (
    <Box className={styles.messages}>
      {messages.map(({ header, message }) => (
        <AText
          key={header}
          breed="R"
          color="txt_color_7"
          size="m"
          component="div"
          className={styles.message}
        >
          <AText breed="B">{t(header)}</AText>
          {t(message)}
        </AText>
      ))}
    </Box>
  );
};
